// src/api/productDetail.ts
import { productsApi } from '../api'
import { Product } from '../api-client';

// Función para obtener un producto detallado por ID
export const fetchProductDetail = async (id: number): Promise<Product> => {
  try {
    const response = await productsApi.productsProductsRetrieve({id});
    return response.data;
  } catch (error) {
    console.error("Error fetching product detail:", error);
    throw error;
  }
};
